module.exports = __webpack_public_path__ + "static/media/n3.d028b30c.svg";